import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-95eeb0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pic" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pic-img-3d",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "txt" }
const _hoisted_5 = { class: "title nowrap" }
const _hoisted_6 = {
  key: 0,
  class: "attr nowrap"
}
const _hoisted_7 = { class: "price" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "zhekou"
}
const _hoisted_10 = { class: "click-num" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = {
  key: 0,
  class: "right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["goods-info", { 'goods-info-b': _ctx.showBorder }])
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'productDetail', params: { id: _ctx.goods.id } },
      target: "_blank"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "pic-img",
            src: _ctx.changeUrl(_ctx.goods.photo)
          }, null, 8, _hoisted_2),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.goods.names), 1),
          (_ctx.goods.attr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goods.attr.split(' '), (attr, index) => {
                  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(attr), 1))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.isActivity()
							? parseInt(_ctx.goods.activity_price)
							: Math.round(_ctx.goods.price)), 1),
            (_ctx.isActivity())
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.getZheKou()) + "折", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.goods.click) + "次浏览", 1),
            (_ctx.goods.author)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "header",
                    style: _normalizeStyle({ background: 'url(' + _ctx.goodsImg + ') no-repeat' })
                  }, null, 4)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}